<div mat-dialog-content>
    <div class="pqr-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-pqrPqrsNew (closeDialog)="onClose()" [pqrsId]="pqrsId"></app-pqrPqrsNew>
</div>